<template>
  <span class="currency-wrap">
    <!-- 单行 -->
    <template>
      <span v-if="isShowCny" class="origin-price-box">
        <span class="display-symbol">
          {{
            `${needDisplaySymbol ? currencyCfg.displaySymbol : ''}${
              currencyCfg.spaceBetSymbol ? ' ' : ''
            }`
          }}
        </span>
        <span class="display-number">
          {{
            `${
              needDisplayPrecision
                ? displayWithPrecision
                : displayWithoutPrecision
            }`
          }}
        </span>
      </span>
      <!-- 转换行为固定样式 精度等-->
      <template v-if="isTransferInView">
        <span class="transfer-price-box">
          <br v-if="transferLineBreak" />
          ({{ aboutText ? '约' : '' }}¥ {{ transferNumWithPrecision }}元)
        </span>
        <!-- 换行 -->
      </template>
    </template>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import BigNumber from 'bignumber.js';
//

// 不包含
export default {
  props: {
    number: {
      type: null,
      default: 0,
    },
    // 是否展示精度
    needDisplayPrecision: {
      type: Boolean,
      default: true,
    },
    // 是否展示符号
    needDisplaySymbol: {
      type: Boolean,
      default: true,
    },
    // 是否包含转换行
    isTransferScene: {
      type: Boolean,
      default: false,
    },
    // 转换后的数值
    transferNum: {
      type: null,
      default: '',
    },
    // 转换是否换行... todo 优化,暂时这么写 比较快
    transferLineBreak: {
      type: Boolean,
      default: true,
    },
    // 约
    aboutText: {
      type: Boolean,
      default: false,
    },
    isShowCny: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['currencyCfg']),
    displayWithPrecision() {
      return BigNumber(this.getProtectNum(this.number)).toFixed(
        this.currencyCfg.displayPrecision
      );
    },
    displayWithoutPrecision() {
      return BigNumber(this.getProtectNum(this.number)).toFixed(0);
    },
    isTransferInView() {
      // 还要再判断该币种是否需要
      return this.isTransferScene && this.currencyCfg.needTransfer;
    },
    transferNumWithPrecision() {
      return BigNumber(this.getProtectNum(this.transferNum)).toFixed(2);
    },
  },
  methods: {
    getProtectNum(num) {
      return num || 0;
    },
    // getFixedNum() {
    //   return;
    // },
  },
};
</script>

<style lang="scss" scoped>
// .display-symbol {
//   font-size: 0.8em; // 当前符号小一点
// }
.display-number {
  white-space: nowrap;
}
.transfer-price-box {
  font-size: 10px;
}
</style>
